import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { AuthenticationDataService } from 'app/core/authentication';

@Injectable({
  providedIn: 'root'
})
export class GameUserHeaderCreator {
  private readonly authenticationDataService = inject(AuthenticationDataService);

  public getHTTPHeaders(): HttpHeaders {
    const headers: HttpHeaders = new HttpHeaders();
    return headers.set('Kh-User-Id', this.getUserId());
  }

  public getUserId(): string {
    return this.authenticationDataService.getUserId() ?? '';
  }
}
